/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Fixed_PriceInputs */

const en_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed price`)
};

const ar_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سعر ثابت`)
};

const bn_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিক্সড প্রাইস`)
};

const de_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festpreis`)
};

const es_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio fijo`)
};

const fr_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix fixe`)
};

const pt_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço fixo`)
};

const zh_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定价格`)
};

const tr_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabit fiyat`)
};

const ru_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фикс-прайс`)
};

const pl_svchip_fixed_price = /** @type {(inputs: Svchip_Fixed_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stała cena`)
};

/**
* | output |
* | --- |
* | "Fixed price" |
*
* @param {Svchip_Fixed_PriceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_fixed_price = /** @type {((inputs?: Svchip_Fixed_PriceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Fixed_PriceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_fixed_price(inputs)
	if (locale === "bn") return bn_svchip_fixed_price(inputs)
	if (locale === "de") return de_svchip_fixed_price(inputs)
	if (locale === "es") return es_svchip_fixed_price(inputs)
	if (locale === "fr") return fr_svchip_fixed_price(inputs)
	if (locale === "pt") return pt_svchip_fixed_price(inputs)
	if (locale === "zh") return zh_svchip_fixed_price(inputs)
	if (locale === "tr") return tr_svchip_fixed_price(inputs)
	if (locale === "ru") return ru_svchip_fixed_price(inputs)
	if (locale === "pl") return pl_svchip_fixed_price(inputs)
	return en_svchip_fixed_price(inputs)
});